import profileEn from './en/en.json'
import profileAr from './ar/ar.json'
import profileEs from './es/es.json'
import profileDe from './de/de.json'
import profileIt from './it/it.json'
import profileFr from './fr/fr.json'
import profilePt from './pt/pt.json'
import profileEl from './el/el.json'
import profileBn from './bn/bn.json'
import profileSr from './sr/sr.json'
import profileCs from './cs/cs.json'
import profilePl from './pl/pl.json'
import profileHu from './hu/hu.json'
import profileSk from './sk/sk.json'
import profileRo from './ro/ro.json'
import profileBg from './bg/bg.json'
import profileMk from './mk/mk.json'
import profileSq from './sq/sq.json'

const ProfileMessages = {
  en: { profile: { ...profileEn } },
  ar: { profile: { ...profileAr } },
  es: { profile: { ...profileEs } },
  de: { profile: { ...profileDe } },
  it: { profile: { ...profileIt } },
  fr: { profile: { ...profileFr } },
  pt: { profile: { ...profilePt } },
  el: { profile: { ...profileEl } },
  bn: { profile: { ...profileBn } },
  sr: { profile: { ...profileSr } },
  cs: { profile: { ...profileCs } },
  pl: { profile: { ...profilePl } },
  hu: { profile: { ...profileHu } },
  sk: { profile: { ...profileSk } },
  ro: { profile: { ...profileRo } },
  bg: { profile: { ...profileBg } },
  mk: { profile: { ...profileMk } },
  sq: { profile: { ...profileSq } },
}

export default ProfileMessages
